import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_ADD_AFFILIATE_PROGRAMS,
  ACTION_LOAD_AFFILIATE_PROGRAMS__REQUEST,
  ACTION_LOAD_AFFILIATE_PROGRAMS__SUCCESS,
  ACTION_LOAD_AFFILIATE_PROGRAMS__FAIL,
} from '../actionTypes';

import { AFFILIATE_PROGRAMS_SCHEMA } from '../schemas';


export const actionAddAffiliatePrograms = affiliatePrograms => ({
  type: ACTION_ADD_AFFILIATE_PROGRAMS,
  payload: { affiliatePrograms },
});

export const actionLoadAffiliateProgramsSuccess = () => ({
  type: ACTION_LOAD_AFFILIATE_PROGRAMS__SUCCESS,
});

export const actionLoadAffiliateProgramsFail = error => ({
  type: ACTION_LOAD_AFFILIATE_PROGRAMS__FAIL,
  payload: { error },
});

export const actionLoadAffiliateProgramsRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_AFFILIATE_PROGRAMS__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/affiliate_program',
      {},
      AFFILIATE_PROGRAMS_SCHEMA
    ).then(
      ({ entities }) => {
        dispatch(actionAddAffiliatePrograms(entities.affiliatePrograms));
        dispatch(actionLoadAffiliateProgramsSuccess());
      },
      error => {
        dispatch(actionLoadAffiliateProgramsFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
